import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XCircleIcon } from "@heroicons/react/outline";
import { motion } from "framer-motion";

const getAnimationVariants = () => {
  return window.innerWidth < 640 // sm breakpoint
    ? {
        hidden: { opacity: 0, y: 50 }, // Slide up from bottom
        visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
        exit: { opacity: 0, y: 50, transition: { duration: 0.2 } },
      }
    : {
        hidden: { opacity: 0, rotateY: 90 }, // Flip effect
        visible: { opacity: 1, rotateY: 0, transition: { duration: 0.3 } },
        exit: { opacity: 0, rotateY: 90, transition: { duration: 0.2 } },
      };
};

const ModalComponent = ({ onClose, show, title, classes, children }) => {
  const flipVariants = getAnimationVariants(); // Get animation based on screen size

  return (
    <Transition appear show={show} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        {/* Overlay */}
        <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm" aria-hidden="true" />

        <div className="fixed inset-0 flex items-center justify-center p-4 text-center">
          <motion.div
            variants={flipVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className={`${classes ? classes : "w-full"} max-w-xl lg:max-w-3xl xl:max-w-5xl 
                        mx-auto transform 
                        bg-white p-5 shadow-2xl 
                        rounded-xl border border-gray-100
                        relative my-4 sm:my-6`}
          >
            <Dialog.Panel>
              <Dialog.Title className="text-lg flex justify-between font-medium leading-6 text-gray-900 sticky top-0 bg-white pb-3 border-b border-gray-100">
                <span className="text-primary text-xl font-semibold">{title}</span>
                <XCircleIcon onClick={onClose} className="w-8 h-8 cursor-pointer text-gray-500 hover:text-primary transition-colors" />
              </Dialog.Title>
              <div className="mt-3">
                {children}
              </div>
            </Dialog.Panel>
          </motion.div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalComponent;